module.exports = __webpack_public_path__ + "static/media/electron-to-go-logo-long.b8bb1146.svg";